/* The shop's colours.
 *
 * Everybody signed in reads them; the office changes them, and the server
 * answers 403 to anyone else. Every write answers with the whole list, ordered
 * the way the office reads it, so the store replaces its list with the answer
 * rather than splicing one colour into it. */
import type { ColourDto, CreateColourRequest, UpdateColourRequest } from '@oneshot2pac/shared';
import { api } from './client';

export const coloursApi = {
  list: () => api.get<ColourDto[]>('/colours'),

  /** A code the shop archived comes back rather than being refused. */
  create: (body: CreateColourRequest) => api.post<ColourDto[]>('/colours', body),

  /** Send only what changed. A new code carries its jobs with it. */
  update: (id: string, body: UpdateColourRequest) =>
    api.patch<ColourDto[]>(`/colours/${encodeURIComponent(id)}`, body),

  /** Off the pickers. The jobs in it keep it. */
  archive: (id: string) => api.post<ColourDto[]>(`/colours/${encodeURIComponent(id)}/archive`),

  /** Back on the pickers. */
  restore: (id: string) => api.post<ColourDto[]>(`/colours/${encodeURIComponent(id)}/restore`),
};
